(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tibhelper-pack-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tibhelper-pack-picker')) {
    customElements.define('tibhelper-pack-picker', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', () => {
          const productInfo = this.closest('product-info');
          if (productInfo) productInfo.dataset.tibhelperPackInitialized = 'true';
        });
        Promise.all([
          customElements.whenDefined('product-info'),
          customElements.whenDefined('variant-selects'),
          customElements.whenDefined('product-form')
        ]).then(() => {
          if (!this.isConnected) return;
          const productInfo = this.closest('product-info');
          const parameters = new URLSearchParams(window.location.search);
          if (!productInfo || productInfo.dataset.updateUrl !== 'true' || productInfo.dataset.tibhelperPackInitialized ||
              this.dataset.defaultPreferred !== 'true' ||
              parameters.has('variant') || parameters.has('option_values')) return;
          productInfo.dataset.tibhelperPackInitialized = 'true';
          const preferred = this.querySelector('[data-preferred-pack]');
          if (!preferred || preferred.checked) return;
          preferred.checked = true;
          preferred.dispatchEvent(new CustomEvent('change', {
            bubbles: true,
            detail: { tibhelperDefaultSelection: true }
          }));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
